// extracted by css-extract-rspack-plugin
export default {"workspaceId":"pQbyrZTfIPdbCpcd"};